import { createBrowserHistory } from 'history';

// TODO: rewrite this as history creator
export default createBrowserHistory();